'use client';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useCallback } from 'react';

import { Button } from '@/shared';
import { useCarousel } from '@/shared/ui/carousel';

export const CarouselNavigationButtons = () => {
	const { index, setIndex, itemsCount } = useCarousel();

	const onPreviousClick = useCallback(() => {
		if (index > 0) {
			setIndex(index - 1);
		}
	}, [index, setIndex]);

	const onNextClick = useCallback(() => {
		if (index < itemsCount - 1) {
			setIndex(index + 1);
		}
	}, [index, itemsCount, setIndex]);

	return (
		<div className="relative z-20 mt-4 hidden items-center justify-end gap-2 px-4 sm:flex">
			<Button
				type="button"
				variant="gray"
				size="40"
				className="w-10 !px-2 disabled:cursor-not-allowed disabled:opacity-30"
				aria-label="Previous slide"
				disabled={index === 0}
				onClick={onPreviousClick}
			>
				<ChevronLeftIcon className="size-5" aria-hidden="true" />
			</Button>
			<Button
				type="button"
				variant="gray"
				size="40"
				className="w-10 !px-2 disabled:cursor-not-allowed disabled:opacity-30"
				aria-label="Next slide"
				disabled={index + 1 === itemsCount}
				onClick={onNextClick}
			>
				<ChevronRightIcon className="size-5" aria-hidden="true" />
			</Button>
		</div>
	);
};
